import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_TOKEN } from '../injection.tokens';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any, protected title: Title) {}

  setTitle(preName: string) {
    this.title.setTitle(`${preName} - ${this.environment.metadata.title}`);
  }
}
